import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HomeCarouselItem2 } from '../home-carousel-item2/home-carousel-item2';
import { HomeCarouselItem1 } from '../home-carousel-item1/home-carousel-item1';
@Component({
  selector: 'section[app-home-carousel]',
  imports: [HomeCarouselItem1, HomeCarouselItem2, MatIconModule],
  templateUrl: './home-carousel.html',
  styleUrl: './home-carousel.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeCarousel {}
